export class LoginCadastroModel{
    cellNumber!: string;
    city!: number;
    codeIndication!: string;
    countryCodeCellNumber!: number;
    email!: string;
    name!: string;
    password!: string;
    state!: number;
}